module.exports = __webpack_public_path__ + "img/0Q3A3452_L.d679aebe.webp";